import { AppContext } from "../../common/AppContext";
import type {
  AbstractFilterSelectProps,
  BaseSelectorOption
} from "../../types/components/selector.types";
import { AbstractFilterSelect } from "./AbstractFilterSelect";

interface DomainSelectorOption extends BaseSelectorOption {
  jobDefinitionDomainId?: string;
}

export class DomainSelector<
  TOption extends DomainSelectorOption = DomainSelectorOption
> extends AbstractFilterSelect<TOption> {
  static contextType = AppContext;

  static defaultProps = {
    ...AbstractFilterSelect.defaultProps,
    label: "Domain (optional):",
    matchFrom: "any" as const
  };

  constructor(props: AbstractFilterSelectProps<TOption>) {
    super(props);
  }

  getItemId(item: TOption) {
    return item.jobDefinitionDomainId || "";
  }

  getItemLabel(item: TOption) {
    const { getItemLabel } = this.props;

    if (getItemLabel) return getItemLabel(item);
    return item as unknown as string;
  }

  getList(dataList: any) {
    return dataList.domain;
  }
}
